import { useContext } from 'react'
import { addHours, format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { Checkbox, Theme, useMediaQuery } from '@mui/material'

import Chip from '../common/chip'
import { Payment } from '../../types'
import { UserContext } from '../../contexts'
import AccountIcon from '../../assets/icons/account-icon.svg'
import CalendarIcon from '../../assets/icons/calendar-icon.svg'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon.svg'

export const PaymentRejectedListItem = ({
  paymentData,
  processingDocument,
  handleGoToPaymentDetails,
  handleTogglePaymentSelection
}: {
  processingDocument?: boolean
  paymentData: Partial<Payment>
  handleGoToPaymentDetails: (paymentData: Partial<Payment>) => void
  handleTogglePaymentSelection: (paymentData: Partial<Payment>, isChecked: boolean) => void
}) => {
  const { userSession } = useContext(UserContext)
  const { t } = useTranslation(['customer-details-management'])
  const lgDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))

  return (
    <div
      onClick={() => handleGoToPaymentDetails(paymentData)}
      className="payment-list-item-data-container"
    >
      <div className="customer-company-table-column customer-company-table-width-15 display-none-xlg customer-company-table-width-70-md-down">
        {!processingDocument && userSession && userSession.role.indexOf('-client') === -1 && (
          <Checkbox
            checked={paymentData.selected ?? false}
            onClick={(event) => event.stopPropagation()}
            onChange={(event) => {
              handleTogglePaymentSelection(paymentData, event.target.checked)
            }}
          />
        )}
        <div className="customer-details-list-item-icon">
          <img
            src={CalendarIcon}
            alt="calendar-icon"
          />
        </div>
        <div className="customer-details-list-item-text">{format(addHours(new Date(String(paymentData?.createdAt)), 5), 'dd/MM/yyyy')}</div>
      </div>
      <div className="customer-company-table-column customer-company-table-width-45">
        {!processingDocument && lgDown && (
          <Checkbox
            checked={paymentData.selected ?? false}
            onClick={(event) => event.stopPropagation()}
            onChange={(event) => {
              handleTogglePaymentSelection(paymentData, event.target.checked)
            }}
          />
        )}
        <div className="customer-details-list-item-icon">
          <img
            src={AccountIcon}
            alt="account-icon"
          />
        </div>
        <div className="customer-details-list-item-text">{paymentData.customerData?.registeredFullName?.toUpperCase()}</div>
      </div>
      <div className="customer-company-table-column customer-company-table-width-45 novelties-container customer-company-table-width-30-md-down">
        <div className="novelty-container">
          <Chip
            status="error"
            label={paymentData.status?.indexOf('error') !== -1 ? t('paymentStatus.error') : paymentData.status?.indexOf('returned') !== -1 ? t('paymentStatus.returned') : t('paymentStatus.rejected')}
          />
        </div>
        <div>
          <img
            src={ArrowRightIcon}
            alt="arrow-right-icon"
          />
        </div>
      </div>
    </div>
  )
}
